export default {
  translation: {
    top: {
      information: 'SOLAR SYSTEM INFORMATION',
      capacity: 'Solar System capacity',
      commissioning: 'Commissioning',
      energyToday: 'SOLAR ENERGY TODAY',
      totalEnergy: 'TOTAL ENERGY',
      temperature: 'TEMPERATURE',
    },
    middle: {
      solarPower: 'SOLAR POWER GENERATION (DAY)',
      currentSolar: 'CURRENT SOLAR POWER',
    },
    bottom: {
      reduction: 'REDUCTION',
      today: 'TODAY',
      total: 'TOTAL',
      savingMoney: 'SAVING MONEY', 
      totalSave : 'TOTAL SAVE',
      thb : 'THB TODAY'
    }
  },
}

